module.exports = __webpack_public_path__ + "img/emo_23.4558cbc9.png";